import type { Project } from '../../aansluiting/project/types/Project'
import { apiClient } from '../../gateways/api'
import type { HoofdleidingProject } from '../../hoofdleiding/project/types/HoofdleidingProject'

export { fetchSearchBar }

const fetchSearchBar = async ({
  id,
}: {
  id: string
}): Promise<(Project | HoofdleidingProject)[]> => {
  const { data } = await apiClient({
    url: `/rest/project/search-bar`,
    method: 'POST',
    data: {
      text: id,
    },
  })

  return data
}
